import ObtenerCampaniaService from './ObtenerCampaniaService';
import DataDog from '../Helpers/DataDog';

async function ObtenerCampaniasService(arrayCampaniaId){
    try {
        const promises = arrayCampaniaId.map((id) => ObtenerCampaniaService({ id: id }));
        const responses = await Promise.all(promises);
    
        const resultado = responses.reduce((acumulador, r) => {
          if (r.code === "0000") {
            if (!acumulador) acumulador = { code: r.code, message: r.message, response: [] };
            acumulador.response.push(r.response);
          }
          return acumulador;
        }, null);
    
        return resultado;
    } catch (error) {
        DataDog.trackCustomEventError('error-obtenerCampanias' , { error });
        return error;
    }
    
}

export {ObtenerCampaniasService}